import { useEffect } from "react";

const VERSION_URL = "/version.json";
const CHECK_INTERVAL = 30000; // 30 sec

export default function useAutoRefresh() {
  useEffect(() => {
    const checkVersion = async () => {
      try {
        const res = await fetch(VERSION_URL, {
          cache: "no-store",
          headers: {
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
          },
        });

        const data = await res.json();

        const storedVersion = localStorage.getItem("app_version");
        if (storedVersion && storedVersion !== data.version) {
          window.location.reload();
        }

        localStorage.setItem("app_version", data.version);
      } catch (err) {}
    };

    checkVersion();
    const interval = setInterval(checkVersion, CHECK_INTERVAL);

    return () => clearInterval(interval);
  }, []);
}
